export enum SendbirdPanel {
    CHANNEL_LIST,
    CHANNEL
}
